export default __webpack_public_path__ + "static/media/img-avatar.47242abd.jpg";